import {
    getModule,
    Module,
    Mutation,
    Action,
    VuexModule,
} from 'vuex-module-decorators';
import store from '@/store';

@Module({
    namespaced: true,
    name: 'alert',
    store,
    dynamic: true,
})
class AlertModule extends VuexModule {
    error: any | null = null;

    @Mutation
    setError(error: any | null) {
        this.error = error;
    }

}

export default getModule(AlertModule);
